import type { FC } from 'react';
import { AccountNumber } from '@george-labs.com/design-system';

import type { BankConnection } from '@shared/products-core';
import { formatIBAN } from '@shared/formatting-utils';

interface Props {
    bankConnection?: Pick<BankConnection, 'iban'> | null;
}

export const ConfidentialIBAN: FC<Props> = ({ bankConnection }) => {
    if (!bankConnection?.iban) {
        return null;
    }

    return <AccountNumber>{formatIBAN(bankConnection.iban)}</AccountNumber>;
};
